// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"bfe5a3be","703":"93912d5e"}[chunkId] + ".chunk.js";
};